// src/utils/dateUtils.js
// Un solo posto per il bug di fuso orario trovato e corretto nei Noleggi: MAI usare
// `toLocalDateStr(qualcheData)` per ricavare una stringa "AAAA-MM-GG" da un
// oggetto Date — toISOString() converte sempre in UTC, e in Italia con l'ora legale (UTC+2)
// questo fa scivolare indietro di un giorno qualunque data vicina alla mezzanotte. Usare
// sempre questa funzione, che legge i componenti LOCALI (anno/mese/giorno) dell'oggetto Date.
export function toLocalDateStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const g = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${g}`;
}

// "Oggi" in formato AAAA-MM-GG, fuso locale — da usare ovunque serva la data odierna come
// stringa (valori di default nei form, vincoli max su input date, ecc.).
export function oggiStr() {
  return toLocalDateStr(new Date());
}
